import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import {
  params, string, arrayOf,
  shape, useDataModel, extend
} from '@thd-nucleus/data-sources';
import {
  DrawerBody, DrawerFooter,
  Typography, Button, DrawerHeader
} from '@one-thd/sui-atomic-components';
import { AddToContext } from '../../AddToContext';
import { SCREENS } from '../../AddToConstants';
import { extractProductIdentifiersForIntent } from '../../../utils/intents.utils';

export const ProductOverview = ({
  itemId, isDisplayOnly, onSubmit
}) => {
  const { addToType } = useContext(AddToContext);

  const { data } = useDataModel('product', {
    variables: {
      itemId
    },
    skip: !itemId
  });
  const { product } = data || {};
  const description = product?.details?.description || '';
  const descriptiveAttributes = product?.details?.descriptiveAttributes || [];

  const showDescriptiveAttributes = descriptiveAttributes.length > 0;

  const handleSubmit = async () => {
    onSubmit(SCREENS.MINI_PIP_PRODUCT_OVERVIEW);
  };

  return (
    <>
      <DrawerBody>
        <div data-testid="mini-pip-product-overview" className="sui-flex sui-flex-col sui-gap-4">
          <DrawerHeader title="About This Product" />
          <Typography data-testid="test-productdescription">{description}</Typography>
          <DrawerHeader title="Highlights" />
          {showDescriptiveAttributes && (
            <ul className="sui-pl-4 sui-pr-1 sui-flex sui-flex-col sui-gap-2">
              {descriptiveAttributes.map((highlight, i) => (
                <li
                  key={`promo-quickview-overview-highlights__highlight-${i}`}
                  // eslint-disable-next-line react/no-danger
                  dangerouslySetInnerHTML={{ __html: highlight.value }}
                />
              ))}
            </ul>
          )}
        </div>
      </DrawerBody>
      <DrawerFooter position="center">
        {!isDisplayOnly && (
          <Button
            data-testid="productOverview-AITP-button"
            variant="secondary"
            fullWidth
            onClick={handleSubmit}
            type="submit"
          >
            Add to {addToType}
          </Button>
        )}
      </DrawerFooter>
    </>
  );
};

ProductOverview.displayName = 'ProductOverview';

ProductOverview.propTypes = {
  itemId: PropTypes.string.isRequired,
  isDisplayOnly: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
};

ProductOverview.defaultProps = {
  isDisplayOnly: false
};

ProductOverview.dataModel = extend(
  {
    product: params({
      itemId: string().isRequired(),
      dataSource: string()
    }).shape({
      itemId: string(),
      dataSources: string(),
      details: shape({
        description: string(),
        descriptiveAttributes: arrayOf(shape({
          value: string()
        }))
      }),
      identifiers: shape({
        itemId: string(),
        storeSkuNumber: string(),
        omsThdSku: string(),
        specialOrderSku: string()
      }),
    })
  }
);
